import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/bg/page_bg01.jpg';
import './steps.css';

const GeneralFaq = () => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-100 pb-5 text-center text-white"
          style={{
            backgroundImage: `url(${Bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="container">
            <h2 className="display-5 fw-bold">General FAQs</h2>
          </div>
        </section>

        <section className="py-5 bg-light">
          <div className="container">
            <div className="accordion" id="faqAccordion">
              {[
                {
                  id: 1,
                  question: "Why do you need my documents while registration?",
                  answer:
                    "We are regulated by Financial Conduct Authority in the UK. It is our legal binding to verify your identity as a UK resident.",
                },
                {
                  id: 2,
                  question: "How can I cancel my transfer?",
                  answer:
                    "Please call or email us as early as possible. If not yet processed, we’ll refund after a small handling charge. Transfers already paid out can't be canceled.",
                },
                {
                  id: 3,
                  question: "Will I get notifications about Transfer status?",
                  answer:
                    "Yes. We send email notifications and you can also view status by logging into your account.",
                },
                {
                  id: 4,
                  question: "You asked me to upload one more document; how can I do that?",
                  answer:
                    "Log in to your account and go to ‘My Account’ > Documents to upload the required files.",
                },
                {
                  id: 5,
                  question:
                    "Why I received email stating transfer complete, but the money is not with recipient?",
                  answer:
                    "Our partner bank may have processed it, but the recipient’s bank may take some time to reflect it. Contact us if it doesn't show within a few hours.",
                },
                {
                  id: 6,
                  question: "Good to know",
                  answer: (
                    <ul className="ps-3">
                      <li>Age: 18 years and above</li>
                      <li>We verify identity (no impact on credit rating)</li>
                      <li>You must be a UK resident</li>
                      <li>Activation depends on document submission</li>
                      <li>Monthly sending limits may apply</li>
                    </ul>
                  ),
                },
                {
                  id: 7,
                  question: "Documents Required",
                  answer: (
                    <ul className="ps-3">
                      <li>Photo ID: Passport, EU ID, or UK Driving License</li>
                      <li>Proof of Address: Utility bill, Bank Statement</li>
                      <li>Source of funds documentation</li>
                      <li>Corporate: Company House Registration</li>
                      <li>Corporate: Company Address Proof</li>
                      <li>Corporate: Company Bank Statement</li>
                    </ul>
                  ),
                },
                {
                  id: 8,
                  question: "How can I pay for my transfer?",
                  answer:
                    "You can pay via bank transfer, debit or credit card. Bank transfer is preferred. Some restrictions and extra charges may apply for cards.",
                },
              ].map((item, index) => (
                <div className="accordion-item mb-3" key={item.id}>
                  <h2 className="accordion-header" id={`heading${item.id}`}>
                    <button
                      className={`accordion-button ${
                        index !== 0 ? 'collapsed' : ''
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded={index === 0 ? 'true' : 'false'}
                      aria-controls={`collapse${item.id}`}
                    >
                      {item.question}
                      
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? 'show' : ''
                    }`}
                    aria-labelledby={`heading${item.id}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <CtaSection />
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default GeneralFaq;
